import { render, staticRenderFns } from "./HeaderCart.vue?vue&type=template&id=0b4aaf24"
import script from "./HeaderCart.vue?vue&type=script&lang=js"
export * from "./HeaderCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLink: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/09062026_084924/resources/assets/marketplace/components/BaseLink.vue').default})
